import { Injectable, inject } from '@angular/core';
import { DomainDetectorService } from './domain-detector.service';
import { EnterpriseLabels, getEnterpriseLabels } from 'lib';

@Injectable({
    providedIn: 'root'
})
export class EnterpriseLabelsFetchService {
    private readonly domainDetectorService = inject(DomainDetectorService);

    private _enterpriseLabels?: EnterpriseLabels;

    async getEnterpriseLabels(): Promise<EnterpriseLabels> {
        if (!this._enterpriseLabels) {
            const domainConfig = await this.domainDetectorService.detectDomain();
            this._enterpriseLabels = getEnterpriseLabels(domainConfig.securityDomain);
        }
        return this._enterpriseLabels;
    }
}

